<template>
  <main class="payout-history-wrapper">
    <h1 id="payouts-history-header">Crypto Payouts admin</h1>
    <form v-on:reset="initForm">
      <fieldset>
        <legend>General information</legend>
        <label>Payout reference
          <input type="text" v-model="searchForm.payoutReference" /></label>
        <label>Payee email<input
            type="email"
            v-model="searchForm.payeeEmail"
            :class="{ invalid: !formValidation.isPayeeEmailValid }" /></label>
        <!-- <label>Account type
          <select v-model="searchForm.accountType">
            <option value="all">All</option>
            <option value="local">Local</option>
            <option value="custody">Custody</option>
          </select>
        </label> -->
        <label>
          Batch ID
          <input
            type="text"
            v-model="searchForm.batchId" />
        </label>
        <label>Balance type
          <select v-model="searchForm.balanceType">
            <option
              v-for="item in balanceTypeList"
              :key="item.typeName"
              :value="item.value">
              {{ item.typeName }}
            </option>
          </select>
        </label>
      </fieldset>
      <fieldset>
        <legend>Last status update</legend>
        <label>Status
          <select v-model="searchForm.status">
            <option value=""></option>
            <option v-for="status in Object.values(PAYOUT_STATUS)" :key="status.value" :value="status.value">
              {{ status.display }}
            </option>
          </select>
        </label>
        <label>From<input
            type="date"
            v-model="searchForm.statusDateFrom"
            :class="{ invalid: !formValidation.areStatusDateValid }" /></label>
        <label>To<input
            type="date"
            v-model="searchForm.statusDateTo"
            :class="{ invalid: !formValidation.areStatusDateValid }" /></label>
      </fieldset>
      <Transition name="fade">
        <fieldset v-if="shouldAdvancedSearchDisplay">
          <legend>Transaction type</legend>
          <label>Sending currency
            <input
              v-model="searchForm.sendingCurrency"
              list="sendingCurrencies" />
            <datalist id="sendingCurrencies">
              <option
                v-for="currency in availableCurrencies"
                :key="currency"
                :value="currency">
                {{ currency }}
              </option>
            </datalist>
          </label>
          <label>Receiving currency
            <input
              v-model="searchForm.receivingCurrency"
              list="receivingCurrencies" />
            <datalist id="receivingCurrencies">
              <option
                v-for="currency in availableCurrencies"
                :key="currency"
                :value="currency">
                {{ currency }}
              </option>
            </datalist>
          </label>
          <label>Payee Address<input
              type="text"
              class="wallet-address"
              v-model="searchForm.payeeWalletAddress" /></label>
        </fieldset>
      </Transition>
      <Transition>
        <fieldset v-if="shouldAdvancedSearchDisplay">
          <legend>Creation Date</legend>
          <label>From<input
              type="date"
              v-model="searchForm.creationDateFrom"
              :class="{ invalid: !formValidation.areCreationDateValid }" /></label>
          <label>To<input
              type="date"
              v-model="searchForm.creationDateTo"
              :class="{ invalid: !formValidation.areCreationDateValid }" /></label>
        </fieldset>
      </Transition>
      <ul class="button-grp">
        <li><button @click.prevent="findPayouts()" class="btn icon-btn search">Search</button></li>
        <li> <button type="reset" class="btn icon-btn">Reset form</button></li>
        <li>
          <button @click.prevent="toggleAdvancedSearch()" class="btn icon-btn" :class="{ 'expand': !shouldAdvancedSearchDisplay, 'less': shouldAdvancedSearchDisplay}">
            {{ shouldAdvancedSearchDisplay ? 'Less parameters' : 'More parameters' }}
          </button>
        </li>
        <li>
          <button @click.prevent="downloadPayoutCSV()" class="btn icon-btn download">Download as CSV</button>
        </li>
      </ul>
      <Transition name="fade">
        <ul
          class="errors-section"
          v-if="!formValidation.isPayeeEmailValid ||
      !formValidation.areCreationDateValid ||
      !formValidation.areStatusDateValid
      ">
          <li v-if="errorDownloadRefundsAsCsv">
            Error in downloading csv file, please try again.
          </li>
          <li v-if="!formValidation.areCreationDateValid">
            <strong>Creation</strong> dates are invalid :
            <strong>To Date</strong> should not be earlier than
            <strong>From Date</strong>
          </li>
          <li v-if="!formValidation.areStatusDateValid">
            <strong>Last modified</strong> dates are invalid :
            <strong>To Date</strong> should not be earlier than
            <strong>From Date</strong>
          </li>
          <li v-if="!formValidation.isPayeeEmailValid">
            Please enter a valid email
          </li>
        </ul>
      </Transition>
    </form>
    <div class="table-wrapper-custom">
      <div>
        <table aria-label="Payout table">
          <thead>
            <tr>
              <th class="sticky-col left">Payout Reference</th>
              <th>Status</th>
              <th>Payee email</th>
              <th>Withdraw amount</th>
              <th class="one-line">
                Total Fee
                <span class="tooltip">
                  <img
                    src="../../assets/icons/help.svg"
                    alt="more info on fees" />
                  <span class="tooltip-text">
                    <strong>GST inclusive if applicable</strong> (merchants
                    incorporated in Singapore)
                  </span>
                </span>
              </th>
              <th>Creation date</th>
              <th>Last status update</th>
              <th>Batch Id</th>
              <th>Account type</th>
              <th class="sticky-col right">Action</th>
            </tr>
          </thead>
          <Transition name="fade">
            <tbody
              is="TransitionGroup"
              name="fade"
              v-if="payoutListGetter.length > 0">
              <tr
                :key="payout.payout_reference"
                v-for="payout in payoutListGetter">
                <td class="sticky-col left">
                  <button
                    class="btn link-style"
                    @click="handleSelectedPayout(payout)">
                    {{ payout.payout_reference }}
                  </button>
                </td>
                <td>
                  <tag>{{ payout.status ? payout.status.replace(/_/g, ' ') : 'status error' }}</tag>
                </td>
                <td>{{ payout.payee_email ? payout.payee_email : '-' }}</td>
                <td>
                  {{
                  payout.account_type === 'local'
                  ? `${payout.payout_currency} ${formatFiatPrice(
                  payout.withdraw_amount
                  )}`
                  : formatCrypto(
                  payout.crypto_currency,
                  payout.net_crypto_amount
                  )
                  }}
                </td>
                <td>{{ getTotalFee(payout) }}</td>
                <td>
                  {{
                  payout.payout_date
                  ? `${formatToLocalDate(
                  payout.payout_date
                  )}, ${formatToLocalTime(payout.payout_date)}`
                  : '-'
                  }}
                </td>
                <td>
                  {{
                  payout.status_date
                  ? `${formatToLocalDate(
                  payout.status_date
                  )}, ${formatToLocalTime(payout.status_date)}`
                  : '-'
                  }}
                </td>
                <td>{{ payout.payout_batch_key ? payout.payout_batch_key : '-' }}</td>
                <td>
                  <span>{{ getAccountType(payout.convert_type) }}</span>
                </td>
                <td class="sticky-col right actions">
                  <span v-if="payout.status === PAYOUT_STATUS.NEW.value">
                    <button
                      v-if="userRights.canResendEmail"
                      class="pure-icon"
                      @click.stop="openResendEmailPopup(payout)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        width="24"
                        fill="#FFF">
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                          d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
                      </svg>
                      <span class="tooltip-text">
                        {{
                        userRights.canChangeEmail
                        ? 'Resend or Change email'
                        : 'Resend email'
                        }}
                      </span>
                    </button>
                    <button
                      v-if="userRights.canCancelCryptoPayout"
                      @click.stop="openConfirmCancelPayoutPopup(payout)"
                      class="pure-icon cancel">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        width="24"
                        fill="#FFF">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      </svg>
                      <span class="tooltip-text">Cancel this payout</span>
                    </button>
                  </span>
                  <span
                    v-else-if="payout.status === PAYOUT_STATUS.PENDING_AUTHORIZATION.value">
                    <button
                      v-if="canApprovePayout(payout)"
                      class="approve pure-icon"
                      @click.stop="openApprovePayoutPopup(payout)">
                      <svg
                        data-v-4c034fe6=""
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="icon-svg feather feather-check-square">
                        <polyline
                          data-v-4c034fe6=""
                          points="9 11 12 14 22 4"></polyline>
                        <path
                          data-v-4c034fe6=""
                          d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                      </svg>
                      <span class="tooltip-text"> Approve this payout </span>
                    </button>
                    <button
                      v-if="userRights.canCancelCryptoPayout"
                      @click.stop="openConfirmCancelPayoutPopup(payout)"
                      class="cancel pure-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        width="24"
                        fill="#FFF">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      </svg>
                      <span class="tooltip-text">Cancel this payout</span>
                    </button>
                  </span>
                  <span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </Transition>
        </table>
        <Transition name="fade">
          <p
            class="emptyTable"
            v-if="!payoutListGetter || (payoutListGetter && payoutListGetter.length <= 0)">
            {{
            firstSearchMade
            ? 'No payouts matches this search, please try with other parameters'
            : "You don't have any payouts yet"
            }}
          </p>
        </Transition>
      </div>
      <ul>
        <li>
          <button class="btn" :disabled="isPrevPayoutListExist" @click="prevPayoutList">
            Previous
          </button>
        </li>
        <li>
          <button class="btn" :disabled="isNextPayoutListExist" @click="nextPayoutList">
            Next
          </button>
        </li>
      </ul>
    </div>

    <!-- Status wiki -->
    <article class="status">
      Here is the meaning of all the statuses used in the table. You can find
      out more about them in the
      <a
        href="https://developers.triple-a.io/docs/triplea-api-doc/0d10abc289f23-payout-statuses"
        target="_blank"
        rel="noopener">Official documentation</a>, or ask your question in the
      <a
        href="https://support.triple-a.io/knowledge"
        target="_blank"
        rel="noopener">FAQ</a>.
      <dl>
        <div v-for="status in Object.values(PAYOUT_STATUS)" :key="status.value">
          <dt>
            <tag>{{status.display}}</tag>
          </dt>
          <dd>{{ status.definition }}</dd>
        </div>
      </dl>
    </article>

    <crypto-batch-payout-history
      :id="isBatch ? pytBatchId : ''"
      :status="isBatch ? batchStatus : ''"
      @lookup-payout-table="handleTableLookup" />

    <!-- Details modal -->
    <triplea-tx-popup-payout
      :shouldDisplay="shouldDisplayDetailsModal"
      @email-clicked="openResendEmailPopup(selectedPayoutGetter)"
      @cancel-clicked="openConfirmCancelPayoutPopup(selectedPayoutGetter)"
      @close-details-modal="closeDetailsModal()" />
    <!-- Email Popup -->
    <vs-prompt
      :active.sync="emailPopup.shouldBeDisplayed"
      title="Resend/Change email"
      :accept-text="emailPopup.acceptButtonText"
      :cancel-text="emailPopup.cancelButtonText"
      buttons-hidden
      :is-valid="!emailPopup.showChangeEmailScreen && emailPopup.selectedPayoutEmail
      "
      class="email-popup">
      <div v-if="emailPopup.hasError" class="icon error">
        <p>
          Error encountered while processing your request for payout
          {{ selectedPayout.payout_reference }}
        </p>
        <div class="button-grp">
          <button @click="goBackToEmailStartScreen()" class="btn">Try again</button>
          <button @click="closeResendEmailPopup()" class="btn outlined">Close</button>
        </div>
      </div>
      <div v-else-if="emailPopup.showSuccessScreen" class="icon">
        <p>
          Email has been sent to
          <strong>{{ emailPopup.selectedPayoutEmail }}</strong> for payout
          <strong>{{ selectedPayout.payout_reference }}</strong>.
        </p>
        <div class="button-grp">
          <button @click="closeResendEmailPopup()">Close</button>
        </div>
      </div>
      <div v-else-if="emailPopup.showChangeEmailScreen">
        <label>Insert a new email <input v-model="emailPopup.newEmail" /></label>
        <div class="button-grp">
          <button @click="goBackToEmailStartScreen()">Back</button>
          <button
            :disabled="!emailPopup.isNewEmailValid"
            @click="updateEmail()">
            Update and send Email
          </button>
        </div>
      </div>
      <div v-else class="resend-email-popup-body">
        <p v-if="emailPopup.selectedPayoutEmail">
          The current Payee email is
          <strong>{{ emailPopup.selectedPayoutEmail }}</strong>.
        </p>
        <p v-else>No email has been set for this Payout.</p>
        <div class="button-grp">
          <button
            v-if="userRights.canResendEmail"
            @click="confirmResendEmail()"
            :disabled="!emailPopup.selectedPayoutEmail"
            class="btn">
            Send email
          </button>
          <button
            v-if="userRights.canChangeEmail"
            @click="goToChangeEmailScreen()"
            class="btn">
            Change Email
          </button>
        </div>
      </div>
    </vs-prompt>
    <!-- Cancel Popup -->
    <vs-prompt
      :active.sync="cancelPopup.shouldBeDisplayed"
      title="Cancel Payout"
      accept-text="Cancel Payout"
      cancel-text="Close"
      color="danger"
      @accept="cancelPayout(selectedPayout)"
      @close="closeConfirmCancelRefundPopup()"
      @cancel="closeConfirmCancelRefundPopup()">
      {{
      cancelPopup.hasError
      ? 'Please try again. An error occurred while processing your request for payout'
      : 'You are trying to cancel the payout '
      }}
      <strong v-if="selectedPayout">{{
        selectedPayout.payout_reference
        }}</strong>
    </vs-prompt>
    <!-- Approve Payout Popup -->
    <vs-prompt
      :active.sync="approvePayoutPopup.shouldBeDisplayed"
      title="Approve Payout"
      accept-text="Approve Payout"
      cancel-text="Cancel"
      :color="approvePayoutPopup.hasError ? 'danger' : 'success'"
      :buttons-hidden="approvePayoutPopup.showSuccessScreen || approvePayoutPopup.hasError
      "
      @accept="approvePayout(selectedPayout)"
      @close="closeApprovePayoutPopup()"
      @cancel="closeApprovePayoutPopup()">
      <div v-if="approvePayoutPopup.showSuccessScreen" class="icon">
        <p>Payout approved successfully!</p>
        <div class="button-grp">
          <button @click="closeApprovePayoutPopup()">Close</button>
        </div>
      </div>
      <div v-else-if="approvePayoutPopup.hasError">
        {{
        approvePayoutPopup.hasError
        ? approvePayoutPopup.errorText
        : 'You are trying to approve the payout '
        }}
        <strong v-if="selectedPayout">{{
          selectedPayout.payout_reference
          }}</strong>
        <div class="button-grp">
          <button @click="approvePayout(selectedPayout)">Try again</button>
          <button @click="closeApprovePayoutPopup()">Cancel</button>
        </div>
      </div>
      <div v-else>
        <div v-if="selectedPayout">
          <strong>{{ selectedPayout.payout_reference }}</strong>
          <p>
            Withdraw Amount
            {{
            selectedPayout.account_type === 'local'
            ? `${selectedPayout.payout_currency} ${formatFiatPrice(
            selectedPayout.withdraw_amount
            )}`
            : formatCrypto(
            selectedPayout.crypto_currency,
            selectedPayout.net_crypto_amount
            )
            }}
          </p>
        </div>
      </div>
    </vs-prompt>
  </main>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { mapActions, mapGetters } from 'vuex';
import TripleaPayoutsHistoryTable from '../../components/triplea-payouts-table/TripleaPayoutsTable';
import { InfoIcon, CheckIcon } from 'vue-feather-icons';
import TripleaTxPopupPayout from '../../components/triplea-tx-popup/TripleaTxPopupPayout';

import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import fileDownload from 'js-file-download';
import { SUPPORTED_OVERALL_CURRENCIES, CRYPTO_PAYOUT_STATUS } from '@/constants.js';
import Tag from '../../atoms/Tag.vue';
import CryptoBatchPayoutHistory from '../../organisms/CryptoBatchPayoutHistory.vue';

export default {
  components: {
    VueApexCharts,
    TripleaPayoutsHistoryTable,
    InfoIcon,
    CheckIcon,
    DatePicker,
    TripleaTxPopupPayout,
    Tag,
    CryptoBatchPayoutHistory,
  },
  props: {
    isBatch: {
      type: Boolean,
      default: false
    },
    pytStatus: {
      type: String,
      default: ''
    },
    pytBatchId: {
      type: String,
      default: ''
    },
    batchId: {
      type: String,
      default: ''
    },
    batchStatus: {
      type: String,
      default: ''
    },

  },
  data() {
    return {
      PAYOUT_STATUS: CRYPTO_PAYOUT_STATUS,
      selectedMerchant: null,
      validateMerchantSelectionError: false,
      maxDate: new Date(Date.now()).toISOString().split('T')[0],
      errorDownloadPayoutAsCsv: false,
      cancelledPayoutReference: '',
      errorCancelPayout: false,
      shouldAdvancedSearchDisplay: false,
      firstSearchMade: false,
      selectedPayout: null,
      shouldDisplayDetailsModal: false,
      availableCurrencies: SUPPORTED_OVERALL_CURRENCIES,
      userRights: {
        canCancelCryptoPayout: false,
        canResendEmail: true,
        canChangeEmail: true,
      },
      searchForm: {
        payoutReference: '',
        payeeEmail: '',
        status: '',
        statusDateFrom: '',
        statusDateTo: '',
        payeeWalletAddress: '',
        creationDateFrom: '',
        creationDateTo: '',
        accountType: 'all',
        balanceType: 'real',
        selectedAccount: '',
        sendingCurrency: '',
        receivingCurrency: '',
        batchId: '',
      },
      formValidation: {
        isPayeeEmailValid: true,
        areStatusDateValid: true,
        areCreationDateValid: true,
        isWalletAddressSafe: true,
      },
      emailPopup: {
        shouldBeDisplayed: false,
        cancelButtonText: 'Cancel',
        acceptButtonText: 'Send Payout Email',
        hasError: false,
        errorText:
          'There was an error processing your request. Please try again',
        newEmail: '',
        showChangeEmailScreen: false,
        isNewEmailValid: false,
        selectedPayoutEmail: '',
        showSuccessScreen: false,
        hasChangeEmailRequestSucceed: false,
        hasEmailBeenSent: false,
      },
      cancelPopup: {
        shouldBeDisplayed: false,
        hasError: false,
        errorText: '',
      },
      approvePayoutPopup: {
        shouldBeDisplayed: false,
        hasError: false,
        errorText:
          'There was an error processing your request. Please try again',
        showSuccessScreen: false,
      },
      balanceTypeList: [
        {
          typeName: 'All',
          value: '',
        },
        {
          typeName: 'Real Balance',
          value: 'real',
        },
        {
          typeName: 'Test Balance',
          value: 'test',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'activeAccountGetter',
      'cleanedTransactionsGetter',
      'payoutsGetter',
      'payoutListGetter',
      'selectedPayoutGetter',
      'activeMerchantKeyGetter',
      'merchantsGetter',
      'activeUserGetter',
      'payoutMetaDataGetter',
      'activeMerchantGetter',
      'currentActiveEntityAdminGetter',
      'approversGetter',
      'approvalGetter',
    ]),
    merchantList() {
      let merchants =
        this.merchantsGetter &&
        this.merchantsGetter.filter((item) => item.can_withdraw);
      return merchants;
    },
    isNextPayoutListExist() {
      if (this.payoutMetaDataGetter && this.payoutMetaDataGetter.next) {
        return false;
      } else {
        return true;
      }
    },
    isPrevPayoutListExist() {
      if (this.payoutMetaDataGetter && this.payoutMetaDataGetter.prev) {
        return false;
      } else {
        return true;
      }
    },
    getInputSelectedAccount() {
      return this.searchForm.selectedAccount;
    },
    getInputBalanceType() {
      return this.searchForm.balanceType;
    },
    getNewEmailInput() {
      return this.emailPopup.newEmail;
    },
    emailPopupDisplayState() {
      return this.emailPopup.shouldBeDisplayed;
    },
  },
  watch: {
    payoutsGetter(newValue) {
      this.payouts = newValue;
    },
    cleanedTransactionsGetter() {
      this.initPage();
    },
    getNewEmailInput(newVal) {
      if (this.isEmail(newVal)) {
        this.emailPopup.isNewEmailValid = true;
      } else {
        this.emailPopup.isNewEmailValid = false;
      }
    },
    selectedPayoutGetter(newVal) {
      this.selectedPayout = newVal;
    },
    emailPopupDisplayState(newVal) {
      // close properly whe clicking outside of popup
      if (!newVal) {
        this.closeResendEmailPopup();
      }
    },
    activeMerchantGetter() {
      this.getRights();
      this.apiGetApprovers(this.activeMerchantGetter.id);
      this.apiGetApproval(this.activeMerchantGetter.id);
      this.findPayouts();
    },
  },
  mounted() {
    this.initPage();
  },
  beforeCreate() {
    this.$store.commit('UPDATE_PAYOUT_LIST', []);
  },
  beforeDestroy() {
    this.$store.commit('UPDATE_PAYOUT_LIST', []);
  },
  methods: {
    ...mapActions([
      'fetchMerchantWithdrawList',
      'downloadPayoutAsCSV',
      'fetchNextPayoutListAction',
      'fetchPrevPayoutListAction',
      'apiGetApprovers',
      'apiGetApproval',
    ]),
    initPage() {
      // TODO refactor the current pageInit function
      this.account = this.activeAccountGetter;
      if (!this.account || !this.account.apiId) {
        console.error('No active wallet found.');
        return;
      }
      const merchantKey = this.activeMerchantKeyGetter;
      this.selectedMerchant = merchantKey;

      const obj = {
        merchant_key: this.selectedMerchant,
        bal_type: this.searchForm.balanceType,
        account_type: ['local-crypto', 'custody-crypto'],
      };
      if (!this.isBatch) {
        if (this.pytStatus) {
          obj.status = this.status;
        }
        if (this.pytBatchId) {
          obj.batch_id = this.batchId;
        }
      }
      this.$store.dispatch('fetchMerchantWithdrawList', obj).then(() => {
        if (this.isBatch) {
          this.scrollToBatchHistory();
        }
      });
      this.getRights();
      this.initForm();

      this.apiGetApprovers(this.activeMerchantGetter.id);
      this.apiGetApproval(this.activeMerchantGetter.id);


    },

    // user actions
    findPayouts() {
      if (!this.isFormValid()) {
        return;
      }
      this.firstSearchMade = true;
      const payload = this.buildPayload();
      if (!payload) {
        console.error('could not build valid payload');
        return;
      }
      this.$store.dispatch('fetchMerchantWithdrawList', payload);
    },
    downloadPayoutCSV() {
      if (!this.isFormValid()) {
        return;
      }
      const payload = this.buildPayload();
      payload.type = 'withdraw';

      this.downloadPayoutAsCSV(payload)
        .then((res) => {
          fileDownload(res.data, 'payouts.csv');
          this.errorDownloadPayoutAsCsv = false;
        })
        .catch(() => {
          this.errorDownloadPayoutAsCsv = true;
        });
    },
    async nextPayoutList() {
      if (this.payoutMetaDataGetter.next) {
        try {
          const payload = {};
          payload.merchant_key = this.selectedMerchant;
          await this.fetchNextPayoutListAction(payload);
        } catch (err) {
          console.error('Fetch Next PayoutList error', err);
        }
      }
    },
    async prevPayoutList() {
      if (this.payoutMetaDataGetter.prev) {
        try {
          const payload = {};
          payload.merchant_key = this.selectedMerchant;
          await this.fetchPrevPayoutListAction(payload);
        } catch (err) {
          console.error('Fetch Prev PayoutList error', err);
        }
      }
    },
    updateEmail() {
      const payload = {
        merchant_key: this.activeMerchantGetter.merchant_key,
        payout_reference: this.selectedPayout.payout_reference,
        newEmail: this.emailPopup.newEmail,
      };
      this.$store
        .dispatch('updateEmail', payload)
        .then((res) => {
          this.emailPopup.selectedPayoutEmail = res.data.email;
          const updatedPayout = { ...this.selectedPayoutGetter, ...res.data }; // quickwin to have the popup updated
          updatedPayout.payee_email = res.data.email;
          this.$store.commit('UPDATE_SELECTED_PAYOUT', updatedPayout);
          this.searchForm.email = ''; // because if we update the email while this filter is on, user might not understand why the refund disappeared
          this.emailPopup.showSuccessScreen = true;
          this.findPayouts();
        })
        .catch((err) => {
          throw err;
        });
    },
    cancelPayout(pyt) {
      const data = {};
      data.operator = this.activeUserGetter && this.activeUserGetter.email;
      data.merchantKey = this.activeMerchantGetter.merchant_key;

      this.$recaptchaLoaded().then(() => {
        this.$recaptcha('browser_access').then((token) => {

          data.recaptchaToken = token;

          this.payoutCancellation(pyt.payout_reference, data).then((res) => {
            if (res.status === 200) {
              this.errorCancelPayout = false;
              const updatedPyt = { ...pyt, ...res.data }; // quickwin to have the popup updated
              this.$store.commit('UPDATE_SELECTED_PAYOUT', updatedPyt);
              // pull the list again to have the updates
              this.findPayouts();
              this.apiGetMerchants().then(res => {
                this.$store.commit('UPDATE_ACTIVE_MERCHANT', res.data.find(merchant => merchant.merchant_key === data.merchantKey));
              });
            }
          }).catch(() => {
            this.$vs.notify({
              title: 'Cancel Payout Error',
              text: 'There is an error in cancelling payout. Please re-login to the dashboard and try again',
              color: 'danger',
            });
          });
        }).catch(() => {
          this.$vs.notify({
            title: 'Recaptcha Error',
            text: 'Error in cancelling payout. Please refresh or try re-login again.',
            color: 'danger',
          });
        });
      });
    },

    approvePayout(pyt) {
      this.apiApprovePayout(pyt.payout_reference)
        .then(() => {
          this.approvePayoutPopup.hasError = false;
          this.approvePayoutPopup.showSuccessScreen = true;
          this.approvePayoutPopup.shouldBeDisplayed = true;
        })
        .catch((err) => {
          this.approvePayoutPopup.hasError = true;
          this.approvePayoutPopup.showSuccessScreen = false;
          this.approvePayoutPopup.shouldBeDisplayed = true;
          let text = '';
          if (err.message && err.message.includes('payout_is_approved')) {
            text = 'Payout has already been approved';
          } else {
            text =
              'Please try again. An error occurred while processing your request for payout';
          }
          this.approvePayoutPopup.errorText = text;
        });
    },

    // Details Modal
    closeDetailsModal() {
      this.shouldDisplayDetailsModal = false;
      this.selectedPayout = null;
      this.$store.commit('UPDATE_SELECTED_PAYOUT', null);
    },

    // email popup display functions
    openResendEmailPopup(payout) {
      this.emailPopup.shouldBeDisplayed = true;
      this.selectedPayout = payout;
      this.emailPopup.selectedPayoutEmail = payout.payee_email;
    },
    confirmResendEmail() {
      const activeMerchantKey = this.activeMerchantGetter.merchant_key;
      const payload = {};
      payload.merchant_key = activeMerchantKey;
      payload.payout_reference = this.selectedPayout.payout_reference;
      this.$store
        .dispatch('resendEmail', payload)
        .then((res) => {
          if (res.status === 200) {
            this.emailPopup.showSuccessScreen = true;
            this.emailPopup.hasEmailBeenSent = true;
            this.showResendEmailPopup = false;
            this.emailPopup.showSuccessScreen = true;
          } else {
            this.emailPopup.hasError = true;
            this.emailPopup.errorText = res.message;
          }
        })
        .catch((err) => {
          this.emailPopup.hasError = true;
          this.emailPopup.errorText = err.message;
          throw err;
        });
    },
    closeResendEmailPopup() {
      this.emailPopup.shouldBeDisplayed = false;

      this.emailPopup.newEmail = '';
      this.emailPopup.showChangeEmailScreen = false;
      this.emailPopup.isNewEmailValid = false;
      this.emailPopup.selectedPayoutEmail = '';
      this.emailPopup.showSuccessScreen = false;
      this.emailPopup.hasChangeEmailRequestSucceed = false;
      this.emailPopup.hasEmailBeenSent = false;
    },

    // Cancel popup display functions
    openConfirmCancelPayoutPopup(payout) {
      this.selectedPayout = payout;
      this.cancelPopup.shouldBeDisplayed = true;
    },
    closeConfirmCancelRefundPopup() {
      this.cancelPopup.shouldBeDisplayed = false;
    },

    openApprovePayoutPopup(payout) {
      this.selectedPayout = payout;
      this.approvePayoutPopup.shouldBeDisplayed = true;
    },
    closeApprovePayoutPopup() {
      this.approvePayoutPopup.shouldBeDisplayed = false;
      this.approvePayoutPopup.hasError = false;
      this.approvePayoutPopup.showSuccessScreen = false;
    },

    // getters
    getRights() {
      const currentActiveMerchantId =
        this.activeMerchantGetter && this.activeMerchantGetter.id;
      //determine to show if the user has permission to cancel a payout or not
      this.userRights.canCancelCryptoPayout = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'D'
      );
      this.userRights.canResendEmail = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'R'
      );
      this.userRights.canChangeEmail = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'W'
      );
    },

    canApprovePayout(pyt) {
      return (
        !pyt.is_approved &&
        this.approversGetter
          .map((approver) => approver.entity_admin_id)
          .includes(this.currentActiveEntityAdminGetter.id) &&
        (!pyt.created_by ||
          pyt.created_by != this.currentActiveEntityAdminGetter.email)
      );
    },

    getTotalFee(pyt) {
      if (pyt.account_type === 'custody') {
        return this.formatAmount(
          this.formatCryptoPrice(pyt.crypto_amount_fee + pyt.vat_crypto_amount),
          pyt.crypto_currency
        );
      }
      return this.formatAmount(
        this.formatFiatPrice(pyt.fiat_amount_fee + pyt.vat_fiat_amount),
        pyt.payout_currency
      );
    },

    // validation and checks
    isFormValid() {
      let isDataValid = true;
      // email
      if (
        this.searchForm.payeeEmail &&
        !this.isEmail(this.searchForm.payeeEmail)
      ) {
        this.formValidation.isPayeeEmailValid = false;
        isDataValid = false;
      } else {
        this.formValidation.isPayeeEmailValid = true; // resetting error value
      }
      // Creation dates
      if (
        !this.areDatesValid(
          this.searchForm.creationDateFrom,
          this.searchForm.creationDateTo
        )
      ) {
        isDataValid = false;
        this.formValidation.areCreationDateValid = false;
      } else {
        this.formValidation.areCreationDateValid = true;
      }
      // Modified dates
      if (
        !this.areDatesValid(
          this.searchForm.statusDateFrom,
          this.searchForm.statusDateTo
        )
      ) {
        isDataValid = false;
        this.formValidation.areStatusDateValid = false;
      } else {
        this.formValidation.areStatusDateValid = true;
      }

      return isDataValid;
    },
    areDatesValid(fromD, toD) {
      if (!fromD || !toD) return true; // only one set
      if (
        fromD &&
        toD &&
        new Date(fromD) < new Date(toD) &&
        new Date(fromD) !== new Date(toD)
      ) {
        this.invalidDates = false;
        return true;
      } else {
        this.invalidDates = true;
        return false;
      }
    },
    resetDates() {
      this.fromDate = '';
      this.toDate = '';
    },
    isTestAccount(apiId) {
      return apiId.includes('_t');
    },

    // handlers and toggles
    handleSelectedPayout(pyt) {
      this.selectedPayout = pyt;
      this.$store.commit('UPDATE_SELECTED_PAYOUT', pyt);
      this.$store.commit('UPDATE_POPUP_DISPLAY_COUNTER');
      this.shouldDisplayDetailsModal = true;
    },
    initForm(event) {
      if (event) event.preventDefault();
      this.resetSearchForm();
      this.findPayouts();
    },

    toggleAdvancedSearch() {
      this.shouldAdvancedSearchDisplay = !this.shouldAdvancedSearchDisplay;
    },
    handleClosingDetailsPopup() {
      this.shouldDisplayDetailsModal = false;
      this.selectedRefund = null;
      this.closeConfirmCancelRefundPopup();
    },
    goToChangeEmailScreen() {
      this.emailPopup.showChangeEmailScreen = true;
    },
    goBackToEmailStartScreen() {
      this.emailPopup.showChangeEmailScreen = false;
      this.emailPopup.hasError = false;
      this.emailPopup.showSuccessScreen = false;
    },
    shouldDisplayCancelButton(pyt) {
      return (
        pyt.status === this.PAYOUT_STATUS.NEW.value &&
        pyt.convert_type !== 'local-local' &&
        this.userRights.canCancelCryptoPayout
      );
    },
    isReceivingAccountLocal(convert_type) {
      const receiveLocalRegex = /.*(local)/;
      return receiveLocalRegex.test(convert_type);
    },
    isAccountLocal(acc) {
      return acc === 'local';
    },

    scrollToBatchHistory() {
      const batchHistoryHeader = document.getElementById('batch-history-header');
      batchHistoryHeader.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    },

    scrollToPayoutsHistory() {
      const payoutsHistoryHeader = document.getElementById('payouts-history-header');
      payoutsHistoryHeader.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    },

    handleTableLookup(batchId) {
      this.resetSearchForm();
      this.searchForm.batchId = batchId;
      this.findPayouts();
      this.scrollToPayoutsHistory();
    },

    // formatting functions
    buildPayload() {
      const payload = {};
      payload.merchant_key =
        this.activeMerchantGetter && this.activeMerchantGetter.merchant_key;
      if (this.searchForm.payoutReference) { payload.payout_reference = this.searchForm.payoutReference; }
      if (this.searchForm.payeeEmail) { payload.email = this.replaceReservedChars(this.searchForm.payeeEmail); }
      if (this.searchForm.status) { payload.status = this.searchForm.status; }
      if (this.searchForm.statusDateFrom) {
        payload.from_modified_date = this.formatDate(
          this.searchForm.statusDateFrom
        );
      }
      if (this.searchForm.statusDateTo) {
        payload.to_modified_date = this.getNextDay(
          this.searchForm.statusDateTo
        );
      }
      if (this.searchForm.creationDateFrom) { payload.from_date = this.formatDate(this.searchForm.creationDateFrom); }
      if (this.searchForm.creationDateTo) { payload.to_date = this.getNextDay(this.searchForm.creationDateTo); }
      if (this.searchForm.balanceType) { payload.bal_type = this.searchForm.balanceType; }
      if (this.searchForm.payeeWalletAddress) { payload.wallet_address = this.searchForm.payeeWalletAddress; }
      if (this.searchForm.accountType) {
        payload.account_type = [];
        if (
          this.searchForm.accountType === 'local' ||
          this.searchForm.accountType === 'custody'
        ) {
          payload.account_type.push(this.searchForm.accountType + '-crypto'); // only supporting crypto payouts for now, waiting for dev on others
        } else {
          payload.account_type = ['local-crypto', 'custody-crypto'];
        }
      }
      if (this.searchForm.receivingCurrency) {
        payload.receiving_currency = this.searchForm.receivingCurrency;
      }
      if (this.searchForm.sendingCurrency) {
        payload.sending_currency = this.searchForm.sendingCurrency;
      }
      if (this.searchForm.batchId) {
        payload.batch_id = this.searchForm.batchId;
      }

      return payload;
    },

    formatCrypto(currency, amount) {
      const regexUsdtUsdc = /.*(USDT|USDC).*/;
      if (regexUsdtUsdc.test(currency)) {
        return `${this.formatFiatPrice(amount)} ${currency}`;
      }
      return `${this.formatCryptoPrice(amount)} ${currency}`;
    },
    getAccountType(convert_type) {
      /**
         *  <div class="xs-show" v-if="data[indextr].convert_type === 'custody-crypto'">Custody (received in crypto)</div>
                      <div class="xs-show" v-else-if="data[indextr].convert_type === 'custody-local'">Custody (received in local currency)</div>
                      <div class="xs-show" v-else-if="data[indextr].convert_type === 'local-crypto'">Local currency (received in crypto)</div>
                      <div class="xs-show" v-else-if="data[indextr].convert_type === 'local-local'">Local currency (received in local currency)</div>

         */
      switch (convert_type) {
        case 'custody-crypto':
          return 'Custody (received in crypto)';
        case 'custody-local':
          return 'Custody (received in local currency)';
        case 'local-crypto':
          return 'Local currency (received in crypto)';
        case 'local-local':
          return 'Local currency (received in local currency)';
      }
    },
    getTotalFeeFIAT(payout) {
      // add network fee (check what is network fee's currency)
      if (this.isAccountLocal(payout.account_type)) {
        // Sum the 3A fee and the network fee
        return this.formatFiatPrice(
          payout.fiat_amount_fee +
          payout.network_fee_crypto_amount * payout.display_exchange_rate
        );
      } else {
        // custody account
        // as the 3A fee (fiat_amount_fee) is a local we would have to convert to crypto,
        // but for custody accounts the exchange rate is negative sometimes
        return this.formatCryptoPrice(
          payout.crypto_amount - payout.net_crypto_amount
        );
      }
    },

    resetSearchForm() {
      this.searchForm = {
        payoutReference: '',
        payeeEmail: '',
        status: '',
        statusDateFrom: '',
        statusdateTo: '',
        payeeWalletAddress: '',
        creationDateFrom: '',
        creationDateTo: '',
        accountType: 'all',
        balanceType: 'real',
        selectedAccount: '',
        sendingCurrency: '',
        receivingCurrency: '',
        batchId: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
main.payout-history-wrapper {
  position: relative;
  scroll-behavior: smooth;

  &>h1 {
    text-transform: uppercase;
    font-size: 32px;
    font-weight: bold;
    color: #505050;
    margin-bottom: 24px;
  }

  form {
    margin-bottom: $margin-m;
    display: flex;
    flex-wrap: wrap;

    fieldset {
      border: none;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 12px;
      margin-right: 32px;
      align-items: flex-end;

      label {
        font-size: 12px;
        padding-right: 6px;
        min-width: 100px;

        &:last-of-type {
          padding-right: 0;
        }
      }

      input,
      select {
        display: block;
        width: 100%;
        height: 38px;
        border-radius: 5px;
        padding: 3px;
        border: 0.5px solid lightgrey;

        &[type='date'] {
          min-width: 150px;
        }

        &[type='email'] {
          min-width: 300px;
        }

        &.currency {
          text-transform: uppercase;
        }

        &.wallet-address {
          min-width: 300px;
        }

        &.invalid {
          border-color: red;
        }
      }

      select {
        text-transform: capitalize;
      }

      &.dates {
        display: flex;
        align-items: flex-end;

        button {
          background-color: rgb(7, 85, 147);
          color: white;
          padding: 12px;
          margin-left: 8px;
          margin-top: 8px;
          border-radius: 6px;
          border: none;
          text-align: center;
          font-family: 'Montserrat', Helvetica, Arial, sans-serif;
          font-size: 1rem;
          max-height: 38px;

          &:hover {
            cursor: pointer;
            background-color: rgb(5, 59, 102);
          }
        }
      }

      &.references {
        p {
          label {
            span {
              font-weight: bold;
            }
          }
        }
      }
    }

    ul.errors-section {
      color: red;
      font-size: 12px;
      display: block;
      width: 100%;
    }

    ul.button-grp {
      li {
        padding: 0px;
        button, input {
          margin-right: 0px;
        }
      }
      
      li:last-child {
        margin-right: 0;
        margin-left: auto;
      }
    }
  }

  div.table-wrapper-custom {
    td {
      button {
        &>.tooltip-text {
          left: -100px;
        }
      }
    }
  }

  article {
    margin-top: 24px;

    dl {
      margin-top: 12px;

      div {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 12px;

        dt {
          margin-right: 6px;
        }
      }
    }
  }
}

.button-grp {
  display: flex;
  flex-wrap: wrap;
  margin-top:$margin-m;
  margin-bottom: $margin-m;
  width: 100%;

  li {
    margin-right: 8px;

    .btn {
      height: 40px;
    }
  }
}

.email-popup {
  div {
    border: none;

    input,
    select {
      display: block;
      width: 100%;
      height: 38px;
      border-radius: 5px;
      padding: 3px;
      border: 0.5px solid lightgrey;

      &[type='email'] {
        min-width: 300px;
      }

      &.invalid {
        border-color: red;
      }
    }

    &.icon {
      p {
        position: relative;
        margin-left: 24px;

        &::before {
          content: '';
          background-image: url('../../assets/icons/checkedTask_green.svg');
          background-size: cover;
          display: inline-block;
          position: absolute;
          height: 24px;
          width: 24px;
          top: calc(50% - 12px);
          left: -30px;
        }
      }

      &.error {
        p::before {
          background-image: url('../../assets/icons/errorIcon_red.svg');
        }
      }
    }
  }

  .button-grp {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    button {
      margin-right: 12px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
